// External packages
import * as React from 'react';

// Components
import { MediaModal } from 'components/MediaModal';

// Types
import { PlaceMap } from '../../../../server/src/types';

type MapPreviewModalProps = {
  modalTrigger?: React.ReactNode;
  map: PlaceMap;
  disableDelete?: boolean;
};

export const MapPreviewModal: React.FC<MapPreviewModalProps> = ({
  modalTrigger,
  map,
  disableDelete = false,
}) => (
  <MediaModal
    modalTrigger={modalTrigger}
    media={{ ...map, altText: map.altText ?? undefined }}
    fileType="placeMaps"
    disableDelete={disableDelete}
    renderMedia={({ altText }) => (
      <img
        className="max-h-[calc(100vh-9.5rem)]"
        height={`${map.height}px`}
        width={`${map.width}px`}
        src={map.url}
        alt={altText}
      />
    )}
  />
);
